export default __webpack_public_path__ + "static/media/Oval-red.d239fac2.svg";